import { gql } from '@apollo/client';

export const DELETE_TAG = gql`
  mutation deleteTag($id: ID!) {
    deleteTag(id: $id) {
      id
      name
    }
  }
`;
